export default __webpack_public_path__ + "static/media/64_mobile.fd74bd93.jpg";